import { render, staticRenderFns } from "./global-events.vue?vue&type=template&id=44c341a8&scoped=true&"
import script from "./global-events.vue?vue&type=script&lang=js&"
export * from "./global-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c341a8",
  null
  
)

export default component.exports